<div class="logistics-overview-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">Logistics Command Center</p>
      <h2>Overview</h2>
      <p class="subtitle">Watch dispatch flow, rider readiness, fleet pressure, and maintenance exposure from one logistics workspace.</p>
    </div>
    <button mat-stroked-button (click)="loadOverview()">Refresh</button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="stats-grid">
    <article class="stat-card primary">
      <span>Today's Deliveries</span>
      <strong>{{ deliveries.length }}</strong>
      <small>{{ inflightActivities }} still moving through the network</small>
    </article>
    <article class="stat-card accent">
      <span>Active Riders</span>
      <strong>{{ activeRiders }}/{{ riders.length }}</strong>
      <small>Field team currently available for dispatch</small>
    </article>
    <article class="stat-card warning">
      <span>Fleet Risk</span>
      <strong>{{ maintenanceRiskCount }}</strong>
      <small>Vehicles currently flagged for maintenance attention</small>
    </article>
    <article class="stat-card success">
      <span>Revenue Today</span>
      <strong>{{ revenueToday | number:'1.0-0' }}</strong>
      <small>{{ unpaidDeliveries }} unpaid and {{ cancelledDeliveries }} cancelled orders</small>
    </article>
  </section>

  <section class="hero-card">
    <div>
      <span class="hero-label">Fleet Live</span>
      <h3>{{ activeVehicles }}/{{ vehicles.length }}</h3>
      <p>Vehicles active today across delivery operations.</p>
    </div>
    <div>
      <span class="hero-label">Distance Logged</span>
      <h3>{{ vehicleAnalytics?.totalDistance || vehicleAnalytics?.distanceToday || 0 | number:'1.0-0' }} km</h3>
      <p>Distance captured from vehicle meter activity.</p>
    </div>
    <div>
      <span class="hero-label">Phone Credit Burn</span>
      <h3>{{ riderAnalytics?.totalCreditUsed || riderAnalytics?.creditUsed || 0 | number:'1.0-0' }}</h3>
      <p>Rider phone work consumption recorded for the day.</p>
    </div>
  </section>

  <section class="content-grid">
    <article class="panel">
      <div class="panel-head">
        <h3>Recent Deliveries</h3>
        <span>Latest 6 orders</span>
      </div>
      <div class="delivery-list" *ngIf="recentDeliveries.length; else noDeliveries">
        <div class="delivery-item" *ngFor="let row of recentDeliveries">
          <div>
            <strong>{{ row.customerName || 'Customer not set' }}</strong>
            <p>{{ row.item || 'Delivery item not specified' }}</p>
          </div>
          <div class="delivery-meta">
            <span>{{ row.pickupLocation || 'Unknown' }} → {{ row.deliveryLocation || 'Unknown' }}</span>
            <small>{{ row.orderDate | date:'medium' }} · {{ row.amount || 0 | number:'1.0-0' }}</small>
          </div>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Route Pressure</h3>
        <span>Most active corridors</span>
      </div>
      <div class="metric-list" *ngIf="routePressure.length; else noRoutes">
        <div class="metric-row" *ngFor="let row of routePressure">
          <strong>{{ row.label }}</strong>
          <span>{{ row.value }} orders</span>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Rider Load</h3>
        <span>Assignments and phone usage</span>
      </div>
      <div class="people-list" *ngIf="riderLoad.length; else noRiders">
        <div class="person-row" *ngFor="let row of riderLoad">
          <strong>{{ row.label }}</strong>
          <span>{{ row.value }} assignments</span>
          <small>{{ row.sublabel }}</small>
        </div>
      </div>
    </article>

    <article class="panel compact wide">
      <div class="panel-head">
        <h3>Fleet Watchlist</h3>
        <span>Highest-maintenance exposure</span>
      </div>
      <div class="watch-list" *ngIf="watchlist.length; else noWatchlist">
        <div class="watch-item" *ngFor="let row of watchlist">
          <div>
            <strong>{{ row.vehiclePlate }}</strong>
            <p>{{ row.model }}</p>
          </div>
          <div class="watch-meta">
            <span [class.alert]="row.needsMaintenance">{{ row.needsMaintenance ? 'Needs service' : 'Within cycle' }}</span>
            <small>{{ row.daysSinceLastMaintenance || 0 }} days · {{ row.totalDeliveries || 0 }} deliveries</small>
          </div>
        </div>
      </div>
    </article>
  </section>
</div>

<ng-template #noDeliveries>
  <p class="muted">No delivery records available yet for today.</p>
</ng-template>

<ng-template #noRoutes>
  <p class="muted">No route data recorded yet.</p>
</ng-template>

<ng-template #noRiders>
  <p class="muted">No rider workload data available yet.</p>
</ng-template>

<ng-template #noWatchlist>
  <p class="muted">No fleet watchlist data available yet.</p>
</ng-template>
